/* @flow */
import * as React from "react";
import type { StylesObject } from "../utils/prefixStyles";
import SliderContainer from "./SliderContainer";
import { HANDLE_SIZE } from "./Handle";

type Props = {
  hasOffState?: ?boolean,
  formatValue?: ?(number) => string,
  showValueAboveHandle?: ?boolean,
  step?: ?number,
  min: number,
  max: number,
  value: number,
  onChange?: ?(value: number) => void,
  onDragStart?: ?(value: number) => void,
  onDragEnd?: ?(value: number, aborted: ?boolean) => void,
  tooltipStyle?: ?StylesObject,
  isHeat?: ?boolean,
  isCool?: ?boolean,
  style?: ?StylesObject,
};

export default class Slider extends React.Component<Props> {
  render() {
    const { style, ...sliderContainerProps } = this.props;
    return (
      <div
        data-component-name="Slider"
        style={{
          paddingRight: HANDLE_SIZE / 2,
          paddingLeft: HANDLE_SIZE / 2,
          ...style,
        }}
      >
        <SliderContainer {...sliderContainerProps} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Slider/index.jsx